var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',[_c('driver-shift-detail-component',{attrs:{"backName":_vm.backName,"rightTopBtn":true,"mapBtnVisibility":true},on:{"transShiftId":_vm.getShiftId}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1301ba6c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/router/views/DriverShiftWithEventDetail.vue
// module id = null
// module chunks = 